import React from 'react'

import { Tag } from '@fourthwall/components'

import * as S from './StockContent.styled'

type StockCellContentProps = {
  type: 'UNLIMITED' | 'MIXED' | 'LIMITED' | 'SOLD_OUT'
  quantity: number | null
  showFullLabel?: boolean
}

export const StockCellContent = ({
  type,
  quantity,
  showFullLabel = false,
}: StockCellContentProps) => {
  const getStockLabel = () => {
    if (type === 'UNLIMITED') {
      return `Unlimited${showFullLabel ? ' stock' : ''}`
    }

    if (type === 'MIXED') {
      return `Mixed${showFullLabel ? ' stock' : ''}`
    }

    if (type === 'SOLD_OUT') {
      return `Sold out${showFullLabel ? ' stock' : ''}`
    }

    if (type === 'LIMITED' && quantity === 0) {
      return showFullLabel ? (
        'Out of stock'
      ) : (
        <S.TagContainer>
          <Tag label="Out" appearance="critical" />
        </S.TagContainer>
      )
    }

    return `${quantity}${showFullLabel ? ' in stock' : ''}`
  }

  return <S.Container>{getStockLabel()}</S.Container>
}
